import { useState } from 'react';
import client from '../api/client';

/**
 * Tiny hook for uploading a single image to /api/uploads/photo.
 * Returns { upload, uploading, progress, error }.
 *
 * Usage:
 *   const { upload, uploading } = usePhotoUpload();
 *   const { url } = await upload(file);   // file = <input type=file> File
 */
export function usePhotoUpload() {
  const [uploading, setUploading] = useState(false);
  const [progress, setProgress] = useState(0);
  const [error, setError] = useState(null);

  async function upload(file) {
    setError(null);
    setUploading(true);
    setProgress(0);
    try {
      const fd = new FormData();
      fd.append('file', file);
      const { data } = await client.post('/uploads/photo', fd, {
        headers: { 'Content-Type': 'multipart/form-data' },
        onUploadProgress: (e) => {
          if (e.total) setProgress(Math.round((e.loaded / e.total) * 100));
        },
      });
      // Make the URL fully qualified through the backend ingress.
      const absoluteUrl = `${process.env.REACT_APP_BACKEND_URL}${data.url}`;
      return { ...data, absoluteUrl };
    } catch (e) {
      const detail = e?.response?.data?.detail || e.message;
      setError(detail);
      throw e;
    } finally {
      setUploading(false);
    }
  }

  return { upload, uploading, progress, error };
}
